module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "TrailbluVisualTesting.36235996.gif";